import { AsyncRegistry } from './registry.types';

export function resolveRegistryEntry<T>(registry: AsyncRegistry<T>, key: string, preset?: string): Promise<T> {
  return Promise.resolve(registry.getEntry(key, preset)()());
}
